export class EmpleadoConyugue {

    constructor({ tipoFrmEmpresa = null } = {}) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;
        this.model = {
            id: { value: null, export: false, header: 'Código' },
            nombres_conyugue: {
                value: '', export: false, header: 'Nombres completos', required: 'Nombres es requerido', maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres', max: 300, min: 4
            },
            apellidos_conyugue: {
                value: '', export: false, header: 'Apellidos completos', required: 'Apellidos es requerido', maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres', max: 300, min: 4
            },
            tipo_identificacion_conyugue: {
                value: null, export: false, header: 'Tipo de identificación', required: 'Tipo de identificación es requerido',
                headerPorTipo: {
                    FRM_TOYOTA: 'Tipo de documento:',
                    FRM_DIFARE: 'Tipo de documento:',
                }
            },
            identificacion_conyugue: {
                value: '', export: false, header: 'Identificación', required: 'Identificación es requerido', maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres', max: 50, min: 4,
                headerPorTipo: {
                    FRM_TOYOTA: 'No. doc. Identidad:',
                    FRM_DIFARE: 'No. doc. Identidad:',
                }
            },
            nacionalidad_conyugue: {
                value: null, export: false, header: 'Nacionalidad', required: 'Nacionalidad es requerido',
                headerPorTipo: {
                    FRM_TOYOTA: 'Nacionalidad:',
                    FRM_DIFARE: 'Nacionalidad:',
                }
            },
            fecha_nacimiento_conyugue: { value: new Date(), export: false, header: 'Fecha de nacimiento:', required: 'Fecha es requerido' },
            lugar_trabajo_conyugue: {
                value: '', export: false, header: 'Nombre del lugar de trabajo:', required: 'Lugar de trabajo es requerido', maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres', max: 300, min: 4
            },
            cargo_conyugue: {
                value: '', export: false, header: 'Cargo:', required: 'Cargo es requerido', maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres', max: 200, min: 4
            },
            actividad_economica: { value: null, export: false, header: 'Actividad Económica:', required: 'Actividad Económica es requerido.' },
            genero_cy: { value: null, export: false, header: 'Género:', required: 'Género es requerido.' },
        }
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
            if (campo.tablePorTipo && tipoFrmEmpresa && campo.tablePorTipo[tipoFrmEmpresa] !== undefined) {
                campo.table = campo.tablePorTipo[tipoFrmEmpresa];
            }
        });
    }

    optionLabel = 'nombre';
}
